import { Button } from '@client/components/ui/button';

interface SelectedAdvisorBarProps {
  advisor: {
    advisorId: string;
    advisorFirstName: string | null;
    advisorLastName: string | null;
    advisorEmail: string;
    organizationDisplayName?: string | null;
    organizationName?: string | null;
  };
  onChangeAdvisor: () => void;
}

export function SelectedAdvisorBar({ advisor, onChangeAdvisor }: SelectedAdvisorBarProps) {
  const fullName = `${advisor.advisorFirstName || ''} ${advisor.advisorLastName || ''}`.trim() || 'Unknown';
  const organization = advisor.organizationDisplayName || advisor.organizationName;

  return (
    <div className="flex-1 flex items-center justify-between">
      <div>
        <p className="text-sm font-medium text-gray-900">
          Managing: {fullName}
        </p>
        <p className="text-xs text-gray-600">
          {advisor.advisorEmail}
          {organization && ` • ${organization}`}
        </p>
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={onChangeAdvisor}
        className="h-8"
      >
        Change Advisor
      </Button>
    </div>
  );
}

